import {
  prependImportToSnippet,
  selectSnippetForStory,
  selectStoryDoc
} from "../../_browser-chunks/chunk-GWNTJ7C3.js";
import {
  seedQueryState
} from "../../_browser-chunks/chunk-QC4HFS6K.js";
import "../../_browser-chunks/chunk-IMSF75WX.js";

// src/shared/open-service/service-definition.ts
var defineService = (def) => def;
export {
  defineService,
  prependImportToSnippet,
  seedQueryState,
  selectSnippetForStory,
  selectStoryDoc
};
